var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#a1a8af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.19 6.374l6.928 4-20 34.641-6.929-4 20-34.64zM117.226 28.19l4 6.928-34.641 20-4-6.929 34.64-20zM128 59.6v8H88v-8h40zM121.626 92.19l-4 6.928-34.641-20 4-6.929 34.64 20z",
    fill: "#eceeef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.81 117.226l-6.928 4-20-34.641 6.929-4 20 34.64z",
    fill: "#e3e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4 128h-8V88h8v40z",
    fill: "#d9dcdf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.81 121.626l-6.928-4 20-34.641 6.929 4-20 34.64z",
    fill: "#d0d3d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.774 99.81l-4-6.928 34.641-20 4 6.929-34.64 20z",
    fill: "#c7cbcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 68.4v-8h40v8H0z",
    fill: "#bdc2c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.374 35.81l4-6.928 34.641 20-4 6.929-34.64-20z",
    fill: "#b4b9bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.19 10.774l6.928-4 20 34.641-6.929 4-20-34.64z",
    fill: "#aab1b7"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64",
    calcMode: "discrete",
    dur: "1080ms",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.752e2fefbed7ee3fb40e317f81def6c7.svg";
export { ForwardRef as ReactComponent };